import { SVG, SVGProps } from './svg'

export function IconCandleBarBasic(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 24 24">
      <path d="M11 0H13V6H16V18H13V24H11V18H8V6H11V0Z" />
    </SVG>
  )
}
